import React, { useState, useEffect } from 'react';
import { Input, Spin } from 'antd';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import columns from '../../../columns/ib/IBTeam.js';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import Eye from '../../../assets/Eye.jsx';
import { GetIBTeamApi, GetUserDetailsByIdApi } from '../../../api/request/ib/ibTeam.js';
import moment from 'moment/moment.js';
import ExportHandler from '../../../components/global/export/ExportHandler.jsx';
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../../hooks/useResponsive.js';
import IBTeamMobile from './IBTeamMobile.jsx';

export default function MyIBTeam() {
    const { isMobile } = useResponsive();
    const { userDetails } = useSelector(state => state.user);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [search, setSearch] = useState('');
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [trader, setTrader] = useState({});
    const [isUserLoading, setIsUserLoading] = useState(false);
    const [valuenew, setValuenew] = useState("All Team");
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const [filterValue, setFilterValue] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const filter = params.get('filter');
        if (filter) {
            setFilterValue(decodeURIComponent(filter));
        }
    }, [location.search]);

    const getIBTeam = async () => {
        try {
            setIsLoading(true);
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FilterText: userDetails?.referralCode,
                ...sorter
            }
            const { data } = await GetIBTeamApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(data?.data?.map((item) => {
                    return ({
                        ...item,
                        name: `${item?.firstName} ${item?.lastName}`,
                        createdDate: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
                        actions: (<div className='cursor-pointer' onClick={() => { setSelectedUserId(item?.userId); setIsOpenModal(true) }}><Eye /></div>)
                    })
                }))
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    const getUserDetails = async () => {
        try {
            setIsUserLoading(true);
            const { data } = await GetUserDetailsByIdApi(selectedUserId);
            if (data?.success) {
                setTrader(data?.data);
                setIsUserLoading(false);
            }
        } catch (error) { }
    }

    useEffect(() => {
        if (filterValue) {
            getIBTeam();
        }
    }, [page, pageSize, searchText, sorter, filterValue]);

    useEffect(() => {
        if (selectedUserId) {
            getUserDetails();
        }
    }, [selectedUserId]);

    useEffect(() => {
        setSearchParams(`filter=${valuenew?.toString()}`);
    }, [valuenew]);

    useEffect(() => {
        if (searchParams?.get("filter")?.trim()) {
            setValuenew(searchParams?.get("filter")?.trim());
        }
    }, []);

    useEffect(() => {
        setSelectedUserId('');
        setTrader({});
    }, [isOpenModal]);

    const exportHandler = async () => {
        try {
            let params = {
                ApplyPagination: false,
                searchKeyword: searchText,
                ...sorter
            };
            const { data } = await GetIBTeamApi(new URLSearchParams(params).toString());

            if (data?.success) {
                return { data: data?.data, removableColumns: ['userId'], fileName: 'My Traders Team' };
            }
            return { data: [], removableColumns: [] };
        } catch (error) {
            return { data: [], removableColumns: [] };
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    if (isMobile) {
        return <IBTeamMobile />;
    }

    return (
        <div>
            <div className="flex items-center justify-between gap-5 flex-wrap">
                <div>
                    <Segmented
                        options={["All Team", "My Team"]}
                        value={valuenew}
                        setValue={(value) => {
                            setValuenew(value);
                            setPage(1);
                        }}
                    />
                </div>

                <div className="flex items-center gap-3 flex-wrap">
                    <Input
                        size="large"
                        style={{ width: 220 }}
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onPressEnter={() => setSearchText(search)}
                        prefix={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                                <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
                            </svg>
                        }
                        suffix={search &&
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                            </svg>
                        }
                    />
                    <div>
                        <ExportHandler exportHandler={exportHandler} />
                    </div>
                </div>
            </div>

            <div className="w-full my-6">
                <div className="border border-gray-200 rounded-xl overflow-x-auto">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>
                <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
            </div>

            <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Trader Information' width={1300}>
                <div>
                    {
                        isUserLoading ? (
                            <div className="flex justify-center flex-col my-[10%]">
                                <Spin size="large" />
                                <p className="primary text-center mt-2">Loading...</p>
                            </div>
                        ) : (
                            <div className='p-5'>
                                <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                                    <div>
                                        <p className='text-base font-normal'>First Name</p>
                                        <p className='text-xl primary font-semibold  mt-2'>{trader?.firstName || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Last Name</p>
                                        <p className='text-xl primary font-semibold  mt-2'>{trader?.lastName || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Email</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.email || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Mobile No.</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.phoneNo || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Country Name</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.countryName || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Affiliate Code</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.affiliateCode || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>All Demo Account</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.demoAccount || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>All Live Account</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.liveAccount || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Live Plan Names</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.livePlan || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Wallet Ac Number</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.walletAccountNo || '--'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Wallet Balance</p>
                                        <p className='text-xl primary font-semibold mt-2'>$ {trader?.walletBalance || '0'}</p>
                                    </div>
                                    <div>
                                        <p className='text-base font-normal'>Created Date</p>
                                        <p className='text-xl primary font-semibold mt-2'>{trader?.createdDate ? moment(trader?.createdDate).format('DD-MM-YYYY LT') : '--'}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </ModalComponent>
        </div>
    )
}
